import { createFileRoute, redirect } from '@tanstack/react-router';

import { currentCohort } from '@/cohort-content';
import { Verification } from '@/features/registration';

export const Route = createFileRoute('/$hci_shortname/verification')({
	beforeLoad: async () => {
		if (!currentCohort) {
			throw redirect({
				to: '/oops',
			});
		}
	},
	component: () => <Verification />,
	head: () => ({
		meta: [
			{
				title: `Verification | ${currentCohort.name}`,
			},
		],
	}),
});
